export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9695.f7b2b166.jpg";